import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { checkWin, utils } from "@alife/cone-arms-core";
var supportedEntryType = utils.supportedEntryType;
export function highlightLcpElement(lcpElement) {
    var highlightColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "red";
    var highlightStyle = "2px solid ".concat(highlightColor);
    if (typeof lcpElement === "string" && lcpElement) {
        var element = document.querySelector(lcpElement);
        if (element) {
            element.style.border = highlightStyle;
        }
    } else if (_instanceof(lcpElement, HTMLElement)) {
        // eslint-disable-next-line no-param-reassign
        lcpElement.style.border = highlightStyle;
    }
}
export function setElementHighlight(currentLcpElement) {
    if (checkWin()) {
        var urlParams = null;
        try {
            urlParams = new URLSearchParams(window.location.search);
        } catch (e) {
        // ignore
        }
        if (urlParams && urlParams.get("needHighlightLcpElement") === "true") {
            highlightLcpElement(currentLcpElement, "red");
            if (urlParams.has("historyLcpElement")) {
                highlightLcpElement(urlParams.get("historyLcpElement"), "yellow");
            }
        }
    }
}
export function calculateNetworkSpeed(resourceTimingList) {
    // 根据资源加载情况，先计算出每个资源的加载网速，单位换算为MB/s，然后取平均值
    if (!resourceTimingList || resourceTimingList.length < 5) {
        return null;
    }
    var resourceSpeedList = resourceTimingList.filter(function(item) {
        return item && (item.transferSize || item.encodedBodySize) > 0 && item.duration > 50 && item.deliveryType !== "cache";
    }).map(function(item) {
        var fileSize = (item.transferSize || item.encodedBodySize || 0) / 1024; // 单位换算为KB
        var duration = item.duration / 1000; // 单位换算为s
        return fileSize / duration;
    });
    if (resourceSpeedList.length < 3) {
        return null;
    }
    var avgSpeed = resourceSpeedList.reduce(function(prev, cur) {
        return prev + cur;
    }, 0) / resourceSpeedList.length;
    return Math.ceil(avgSpeed); // 取整
}
var isCdnResource = function() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return name.indexOf("alipayobjects.com") > -1 || name.indexOf("alicdn.com") > -1;
};
export function getNetworkSpeed() {
    var result = {
        cdnNetworkSpeed: null,
        pageNetworkSpeed: null
    };
    if (checkWin() && typeof performance !== "undefined" && performance.getEntriesByType) {
        var resourceTimingList = performance.getEntriesByType("resource");
        result.cdnNetworkSpeed = calculateNetworkSpeed(resourceTimingList.filter(function(item) {
            var name = item.name || "";
            return isCdnResource(name);
        }));
        result.pageNetworkSpeed = calculateNetworkSpeed(resourceTimingList.filter(function(item) {
            var name = item.name || "";
            return [
                "xmlhttprequest",
                "fetch"
            ].indexOf(item.initiatorType) > -1 && !isCdnResource(name);
        }).concat(performance.getEntriesByType("navigation")));
    }
    return result;
}
export function getResourceDomainInfo() {
    if (checkWin() && supportedEntryType("resource")) {
        var result = {
            dnsPrefetchDomains: [],
            resourceDomainMap: {}
        };
        var resourceTimingList = performance.getEntriesByType("resource");
        resourceTimingList.forEach(function(item) {
            if (item.name && ([
                "xmlhttprequest",
                "fetch"
            ].indexOf(item.initiatorType) || isCdnResource(item.name))) {
                try {
                    var domain = new URL(item.name).origin;
                    if (domain) {
                        result.resourceDomainMap[domain] = (result.resourceDomainMap[domain] || 0) + 1;
                    }
                } catch (e) {
                // ignore
                }
            }
        });
        try {
            var dnsPrefetchDomainsMap = {};
            Array.from(document.getElementsByTagName("link")).filter(function(item) {
                return item.rel === "dns-prefetch" || item.rel === "preconnect";
            }).forEach(function(item) {
                dnsPrefetchDomainsMap[item.href] = true;
            });
            // 去重
            result.dnsPrefetchDomains = Object.keys(dnsPrefetchDomainsMap);
        } catch (e) {
        // ignore
        }
        return result;
    }
    return {};
}
// 压缩PerformanceResourceTiming和PerformanceNavigationTiming数据，只保留部分字段，并将数值字段转换为整数
export function compressPerformanceTimingData(timing) {
    var fields = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var result = {};
    if (!timing || typeof timing !== "object") {
        return result;
    }
    // eslint-disable-next-line guard-for-in
    for(var field in timing){
        var value = timing[field];
        if (typeof value === "number") {
            result[field] = Math.round(value);
        } else if (typeof value === "string" || field === "serverTiming") {
            result[field] = value;
        }
    }
    if (Array.isArray(fields) && fields.length > 0) {
        var finalResult = {};
        fields.forEach(function(field) {
            if (result[field]) {
                finalResult[field] = result[field];
            }
        });
        return finalResult;
    }
    return result;
}
var domTreeMutationObserverList = null;
export function observeDomTreeMutation(callback) {
    if (checkWin() && typeof MutationObserver !== "undefined" && typeof callback === "function") {
        if (Array.isArray(domTreeMutationObserverList)) {
            domTreeMutationObserverList.push(callback);
        } else {
            domTreeMutationObserverList = [
                callback
            ];
            var observerTimer = null;
            try {
                var observer = new MutationObserver(function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    domTreeMutationObserverList = domTreeMutationObserverList || [];
                    if (observerTimer) {
                        clearTimeout(observerTimer);
                    }
                    if (Array.isArray(domTreeMutationObserverList) && domTreeMutationObserverList.length > 0) {
                        observerTimer = setTimeout(function() {
                            if (domTreeMutationObserverList) {
                                domTreeMutationObserverList = domTreeMutationObserverList.filter(function(cb) {
                                    if (typeof cb === "function") {
                                        return cb.apply(void 0, _to_consumable_array(args)) !== true;
                                    }
                                    return false;
                                });
                            }
                        }, 300);
                    }
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: false
                });
            } catch (e) {
            // ignore
            }
        }
    }
}

 //# sourceMappingURL=utils.js.map